<template>
  <div class="grid">
    <loading
      :active="isLoadingModel"
      :can-cancel="true"
      color="#274461"
      :is-full-page="fullPage"
    ></loading>
    <Toast />
    <div class="col-12 sticky">
      <div id="custom_card" class="card">
        <div class="grid justify-content-between">
          <div class="col-12 md:col-6">
            <div
              class="flex flex-wrap align-items-center justify-content-center md:justify-content-start md:mb-0 mb-3"
            >
              <p style="color: #3f51b5; font-size: 20px; font-weight: 800">
                {{ $t("worker_profile_list") }}
              </p>
            </div>
          </div>
          <div class="col-12 md:col-6">
            <div
              class="flex flex-wrap align-items-center justify-content-end md:justify-content-end md:mb-0 mb-3"
            >
              <!-- <Button
                iconPos="right"
                :label="$t('add')"
                v-tooltip.bottom="$t('add')"
                icon="pi pi-plus"
                @click="openNew"
                size="small"
                style=""
              /> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="card" id="custom_card">
        <div class="grid p-fluid">
          <div class="col-12 md:col-12">
            <div class="p-fluid formgrid grid">
              <div class="field col-12 md:col-2">
                <span class="p-float-label">
                  <InputText
                    format="text"
                    v-model="search_filter"
                    @input="search(1)"
                  >
                  </InputText>
                  <label>{{ $t("search") }}</label>
                </span>
              </div>
              <div class="field col-12 md:col-2">
                <span class="p-float-label">
                  <Dropdown
                    id="status"
                    v-model="status_dropdownItem"
                    :options="status_dropdownItems"
                    optionLabel="name"
                    filter
                    @change="search(1)"
                  >
                  </Dropdown>
                  <label for="status">{{ $t("status") }}</label>
                </span>
              </div>
              <div class="field col-2 md:col-2">
                <Button
                  icon="pi pi-refresh"
                  v-tooltip.bottom="$t('refresh')"
                  @click="search(2)"
                  class="p-button-danger"
                  style=""
                />
              </div>
            </div>
          </div>
        </div>
        
        <DataView
          :value="products"
          :layout="layout"        
          :paginator="true"
          :rows="limit"
          :totalRecords="totalRecords"
          :lazy="true"
          :loading="loading"
          @page="onPage($event)"
          :rowsPerPageOptions="PerPageOptions"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
        >
         <template #header>
                <div class="flex justify-content-between align-items-center w-full">
                  <div></div>
                  <div>
                    <SelectButton v-model="layout" :options="options" :allowEmpty="false">
                        <template #option="{ option }">
                            <i :class="[option === 'list' ? 'pi pi-bars' : 'pi pi-table']" />
                        </template>
                    </SelectButton>
                  </div>
                </div>
            </template>
         <template #grid="slotProps">
                <div class="grid grid-cols-12 gap-4" >
                  <div class="border border-gray-300 bg-white rounded flex flex-col justify-between outline outline-2 outline-gray-400 outline-offset-2 h-[320px]">

                          <div class="bg-surface-50 flex justify-center rounded p-5">
                                <div class="relative mx-auto">
                                   <img height="150" width="150" v-if="slotProps.data.photo && slotProps.data.photo!=''" class="block sm:block mx-auto border-round" :src=slotProps.data.photo  />
                                   <img height="150" width="150" v-else class="block sm:block mx-auto border-round " :src=barImage()  />
                                    <div class="absolute bg-black/70 rounded-border" style="left: 4px; top: 4px">
                                        <Tag :value="slotProps.data.status" :severity="getSeverity(slotProps.data)"></Tag>
                                    </div>
                                    <span class="font-medium text-surface-500 dark:text-surface-400 text-lg">👤 {{ slotProps.data.worker_name }}</span>
                                        <div class="text-lg font-medium mt-2">📞 {{ slotProps.data.mobile_no }}</div>
                                         
                                          <Button @click="ViewProfile(slotProps.data)" icon="pi pi-eye"  v-tooltip.bottom="$t('view_profile')"  class="flex-auto whitespace-nowrap mr-2"></Button>
                                        <Button @click="ViewAttendance(slotProps.data)" icon="pi pi-calendar" v-tooltip.bottom="$t('view_attendance')" class="flex-auto whitespace-nowrap mt-2"/>
                                        
                                </div>
                            </div>  
                        </div>
                   
                </div>
            </template>
            <template #list="slotProps">
                <div class="col-12 md:col-12" style="background-color:cornflowerblue;">
                        <div class="flex flex-column sm:flex-row sm:align-items-center p-4 gap-6" :class="{ 'border-top-1 surface-border': index !== 0 } " >
                            <div class="md:w-10rem relative">
                                <img height="100" width="100" v-if="slotProps.data.photo" class="block sm:block mx-auto border-round" :src=slotProps.data.photo />
                                <img height="100" width="100" v-else class="block sm:block mx-auto border-round " :src=barImage()  />

                                <Tag :value="slotProps.data.status" :severity="getSeverity(slotProps.data)" class="absolute" style="left: 4px; top: 4px"></Tag>
                            </div>
                            <div class="flex flex-column md:flex-row justify-content-between md:align-items-center flex-1 gap-4">
                                <div class="flex flex-row md:flex-column justify-content-between align-items-start gap-2">
                                    <div class="flex-1">
                                        <span class="font-medium text-secondary text-white text-xl">👤 {{$t('worker_name')}} : {{ slotProps.data.worker_name ?  slotProps.data.worker_name : "" }}</span>
                                        <div class="text-lg font-medium text-900 text-white mt-2">📞 {{$t('mobile_no')}} : {{ slotProps.data.mobile_no ?  slotProps.data.mobile_no : "" }}</div>
                                        <div class="text-lg font-medium text-900 text-white mt-2">📄 {{$t('registration_number')}} : {{ slotProps.data.Registration_Number ?  slotProps.data.Registration_Number : "" }}</div>
                                        <div class="text-lg font-medium text-900 text-white mt-2">🏘️ {{$t('pan_number')}} : {{ slotProps.data.PAN_Number ?  slotProps.data.PAN_Number : "" }}</div>
                                        <div class="text-lg font-medium text-900 text-white mt-2">🏷️ {{$t('aadhaar_number')}} : {{ slotProps.data.Aadhaar_Number ?  slotProps.data.Aadhaar_Number : "" }}</div>

                                    </div>
                                </div>
                                <div class="flex flex-column md:align-items-end gap-5">
                                    <div class="flex flex-row-reverse md:flex-row gap-2">
                                        <Button @click="ViewProfile(slotProps.data)" v-tooltip.bottom="$t('view_profile')" icon="pi pi-eye" :label="$t('view_profile')" class="flex-auto md:flex-initial white-space-nowrap mt-2 mr-2 "></Button>
                                      <Button @click="ViewAttendance(slotProps.data)" v-tooltip.bottom="$t('view_attendance')" icon="pi pi-calendar" :label="$t('view_attendance')" class="flex-auto md:flex-initial white-space-nowrap mt-2"></Button>
                                      </div>
                                </div>
                            </div>
                        </div>
                   </div>
          
         
            </template>
      </DataView>
      </div>
    </div>
    <Dialog
      v-model:visible="productDialog"
      :breakpoints="{ '960px': '75vw' }"
      :style="{ width: '35vw' }"
      :header="$t('asset_type')"
      :modal="true"
      position="top"
    >
      <div class="col-12">
        <div class="p-fluid formgrid grid" style="margin-top: 2%">
          <div class="field col-12 md:col-12" style="margin-top: 3%">
            <span class="p-float-label">
              <InputText
                id="ticket_title"
                type="text"
                v-model="product.asset_type"
              />
              <label for="name">{{ $t("asset_type") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-12" style="margin-top: 3%">
            <span class="p-float-label">
              <InputText
                id="ticket_title"
                type="text"
                v-model="product.asset_type_mr"
              />
              <label for="name">{{ $t("asset_type_mr") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-12" style="margin-top: 3%">
            <span class="p-float-label">
              <InputText
                id="rate_of_depreciation"
                type="number"
                v-model="product.rate_of_depreciation"
              />
              <label for="name">{{ $t("rate_of_depreciation") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-12" style="margin-top: 3%">
            <span class="p-float-label">
              <Textarea
                rows="6"
                id="remarks"
                type="text"
                v-model="product.remarks"
              />
              <label for="name">{{ $t("remarks") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-12" style="margin-top: 3%">
            <span class="p-float-label">
              <Dropdown
                id="status"
                v-model="addeditstatus_dropdownItem"
                :options="status_dropdownItems"
                optionLabel="name"
                filter
                :disabled="!product._id"
              >
              </Dropdown>
              <label for="status">{{ $t("status") }}</label>
            </span>
          </div>
        </div>
      </div>
      <template #footer>
        <Button
          :label="$t('save')"
          @click="save_event"
          icon="pi pi-check"
          class="p-button-success"
        />
      </template>
    </Dialog>
    <Dialog
      v-model:visible="deleteProductDialog"
      :style="{ width: '450px' }"
      :header="$t('Confirm')"
      :modal="true"
    >
      <div class="flex align-items-center justify-content-center">
        <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
        <span v-if="product"
          >{{ $t("delete_msg") }}<b>{{ product.asset_type }}</b
          >?</span
        >
      </div>
      <template #footer>
        <Button
          :label="$t('no')"
          icon="pi pi-times"
          class="p-button-text"
          @click="deleteProductDialog = false"
        />
        <Button
          :label="$t('yes')"
          icon="pi pi-check"
          class="p-button-text"
          @click="deleteevent"
        />
      </template>
    </Dialog>
  </div>
</template>
  <script>
import { FilterMatchMode } from "primevue/api";
import ProductService from "../service/ProductService";
import apis from "@/apis";
import axios from "axios";
export default {
  data() {
    return {
      rowdata:"",
      options: ['list', 'grid'],
      layout:"grid",
      status_dropdownItems: [
        { name: "Active", value: "Active" },
        { name: "In Active", value: "In Active" },
        { name: "Deleted", value: "Deleted" },
      ],
      status_dropdownItem: null,
      addeditstatus_dropdownItem: null,
      search_filter: "",
      user_key: "",
      page_no: 1,
      isLoading: false,
      PerPageOptions: [10, 50, 100],
      isLoadingModel: false,
      loading: false,
      fullPage: true,
      products: null,
      productDialog: false,
      deleteProductDialog: false,
      deleteProductsDialog: false,
      lazyParams: {},
      product: {},
      selectedProducts: null,
      filters: {},
      offset: 1,
      limit: 10,
      columns: [],
      pageno: 1,
      submitted: false,
      totalRecords: 0,
      id: "",
    };
  },
  productService: null,
  async created() {
    this.productService = new ProductService();
    this.initFilters();
    this.user_key = localStorage.getItem("user_type");
  },
  async mounted() {
    this.id = this.$route.params.id;
    this.lazyParams = {
      first: 0,
      rows: this.limit,
      sortField: null,
      sortOrder: null,
      filters: this.filters,
    };
    if (this.totalRecords == 0) {
      await this.get_count();
    }
    await this.get_list();
  },
  watch: {
    currentLocale() {

    },
    async $route() {
      this.products = [];
      this.columns = [];
      this.totalRecords = 0;
      this.id = this.$route.params.id;
      if (this.id) {
        await this.get_count();
        this.get_list();
      }
    },
  },
  computed: {
    currentLocale() {
      return this.$i18n.locale;
    },
  },
  methods: {
    
    ViewAttendance(product)
    {
        this.rowdata = { ...product };
        localStorage.setItem("product", JSON.stringify(this.rowdata));
        this.$router.push({ name: "Attendance"});
    },
    ViewProfile(product)
    {
        this.rowdata = { ...product };
        localStorage.setItem("product", JSON.stringify(this.rowdata));
        this.$router.push({ name: "ProfileDetails"});
    },
    barImage() {

			return 'images/pic.jpg';
		},
    dateFormatDMY(inputDate) {
      var postdate = inputDate;
      if (inputDate) {
        inputDate = new Date(inputDate);
        if (inputDate.toString() == "NaN-NaN-NaN") {
          return postdate;
        } else {
          let date = ("0" + inputDate.getDate()).slice(-2);
          // current month
          let month = ("0" + (inputDate.getMonth() + 1)).slice(-2);
          // current year
          let year = inputDate.getFullYear();
          if (date.toString() == "aN") {
            return postdate;
          } else {
            return date + "/" + month + "/" + year;
          }
        }
      } else {
        return "";
      }
    },
    getSeverity(product) {
            switch (product.status) {
                case 'Active':
                    return 'success';

                case 'In Active':
                    return 'warning';

                case 'Deleted':
                    return 'danger';

                default:
                    return null;
            }
        },
    async save_event() {
      if (!this.product.asset_type) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_asset_type"),
          life: 3000,
        });
        return false;
      }
      if (!this.product.asset_type_mr) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_asset_type_mr"),
          life: 3000,
        });
        return false;
      }
      if (!this.product.rate_of_depreciation) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_rate_of_depreciation"),
          life: 3000,
        });
        return false;
      }
      if (!this.product.remarks) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_remarks"),
          life: 3000,
        });
        return false;
      }
      if (!this.addeditstatus_dropdownItem) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_status"),
          life: 3000,
        });
        return false;
      }
      var details = {};
      if (this.product._id) {
        details = {
          _id: this.product._id,
          asset_type: this.product.asset_type,
          asset_type_mr: this.product.asset_type_mr,
          remarks: this.product.remarks,
          rate_of_depreciation: this.product.rate_of_depreciation.toString(),
          updated_by: localStorage.getItem("id"),
          status: this.addeditstatus_dropdownItem?.value,
          lang: this.$i18n.locale,
        };
        var promise = apis.updateAssetType(details);
      } else {
        details = {
          asset_type: this.product.asset_type,
          asset_type_mr: this.product.asset_type_mr,
          remarks: this.product.remarks,
          rate_of_depreciation: this.product.rate_of_depreciation.toString(),
          created_by: localStorage.getItem("id"),
          status: this.addeditstatus_dropdownItem?.value,
          client_id: localStorage.getItem("client_id"),
          lang: this.$i18n.locale,
        };
        var promise = apis.createAssetType(details);
      }
      this.isLoadingModel = true;
      promise.then((response) => {
        this.isLoadingModel = false;
        if (response.data.status == true) {
          this.$toast.add({
            severity: "success",
            summary: "success",
            detail: response.data.message,
            life: 3000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: response.data.message,
            life: 3000,
          });
        }
        this.productDialog = false;
        this.get_list();
        this.get_count();
      });
    },
    async search(count) {
      if (count == 2) {
        this.search_filter = "";
        this.status_dropdownItem = null;
      }
      await this.get_list();
      await this.get_count();
    },
    async onPage(event) {
      this.lazyParams = event;
      this.page_no = event.page + 1;
      this.limit = event.rows;
      // console.log(event);
      //  await this.get_count();
      if (this.totalRecords > 0) {
        this.get_list();
      }
    },
    get_count: function () {
      var data = {
        client_id: localStorage.getItem("client_id"),
        status: this.status_dropdownItem?.value,
        search: this.search_filter,
        count: true,
        //AsOnDate: "",
      };
      this.loading = true;
      var promise = apis.WorkerProfileList(data, this.id);
      promise.then((response) => {
        this.loading = false;
        console.log(response);
        this.totalRecords = response.data.data;
        if (this.totalRecords > 100) {
          this.PerPageOptions.push(this.totalRecords);
        }
        //alert(this.totalRecords);
      });
      console.log(data);
    },
    get_list: function () {
      var data = {
        client_id: localStorage.getItem("client_id"),
        status: this.status_dropdownItem?.value,
        search: this.search_filter,
        count: false,
        page_no: this.page_no,
        limit: this.limit,
        //AsOnDate: "",
      };
      this.isLoadingModel = true;
      var promise = apis.WorkerProfileList(data, this.id);
      promise.then((response) => {
        this.isLoadingModel = false;
        console.log(response);
        this.products = response.data.data;
        console.log(this.products[0]);
        if (this.columns.length == 0) {
          if (this.products.length > 0) {
            this.columns = Object.keys(this.products[0]);
          }
        }
      });
      console.log(data);
    },
    openNew() {
      this.product = {};
      this.submitted = false;
      this.productDialog = true;
      this.addeditstatus_dropdownItem = { name: "Active", value: "Active" };
    },
    async editProduct(product) {
      this.file_attachment = "";
      this.product = { ...product };
      this.addeditstatus_dropdownItem = null;
      if (this.product.status) 
      {
        this.addeditstatus_dropdownItem = {
          name: this.product.status,
          value: this.product.status,
        };
      }
      this.productDialog = true;
    },
    confirmDeleteProduct(product) {
      this.product = product;
      this.deleteProductDialog = true;
    },
    deleteevent() {
      if (this.product._id) {
        var data = {
          _id: this.product._id,
          asset_type: this.product.asset_type,
          asset_type_mr: this.product.asset_type_mr,
          remarks: this.product.remarks,
          rate_of_depreciation: this.product.rate_of_depreciation.toString(),
          updated_by: localStorage.getItem("id"),
          status: 'Deleted',
          lang: this.$i18n.locale,
        };
        this.isLoadingModel = true;
        var promise = apis.updateAssetType(data);
        promise.then((responseapi) => {
          this.isLoadingModel = false;
          if (responseapi.data.status == true) {
            this.$toast.add({
              severity: "success", // success, info, warn, error
              summary: this.$t("success"),
              detail: responseapi.data.message,
              life: 3000, // Toast disappears after 3 seconds
            });
            this.deleteProductDialog = false;
            this.get_list();
            this.get_count();
          } else {
            this.$swal("error to Delete Asset Type");
          }
        });
      }
    },
    async exportCSV() {
      this.limit = this.totalRecords;
      this.get_list();
      await this.$refs.dt.exportCSV();
    },
    initFilters() {
      this.filters = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    },
  },
  components: {},
};
</script>
  <style scoped lang="scss">
@import "../assets/demo/badges.scss";
</style>
  